import {
  UPLOAD_AUDIO_MIME_TYPES,
  UPLOAD_IMAGE_MIME_TYPES,
  UPLOAD_VIDEO_MIME_TYPES,
} from 'screens/Finder/components/views/GalleryView/constants'
import { SelectedImage } from 'types'

interface Props {
  url?: string
  type?: string
}

export const isImage = ({ url, type }: Props) =>
  Boolean(
    (url && ['png', 'jpeg', 'svg', 'jpg', 'webp', 'gif'].includes(url.split('.').pop()?.toLowerCase() || '')) ||
      (type && UPLOAD_IMAGE_MIME_TYPES.includes(type)),
  )

export const isVideo = ({ url, type }: Props) =>
  Boolean(
    (url && ['mp4', 'mpeg', 'webm', 'mov'].includes(url.split('.').pop()?.toLowerCase() || '')) ||
      (type && UPLOAD_VIDEO_MIME_TYPES.includes(type)),
  )

export const isAudio = ({ url, type }: Props) =>
  Boolean(
    (url && ['mpeg', 'ogg', 'wav', 'webm'].includes(url.split('.').pop()?.toLowerCase() || '')) ||
      (type && UPLOAD_AUDIO_MIME_TYPES.includes(type)),
  )

export const entityName = (files: SelectedImage[]) => {
  const videos = files.filter(
    (f) => UPLOAD_VIDEO_MIME_TYPES.includes(f.file?.type || f.mime_type || '') || isVideo({ url: f.url }),
  ).length
  const images = files.filter(
    (f) => UPLOAD_IMAGE_MIME_TYPES.includes(f.file?.type || f.mime_type || '') || isImage({ url: f.url }),
  ).length

  let entity = 'image'
  if (videos > 0 && !images) entity = 'video'
  if (videos > 0 && images > 0) entity = 'file'

  return entity
}
